import React from 'react';
import useAppleAnimation from '../hooks/useAppleAnimation';

const InvestmentStructure = () => {
  const fadeInRef = useAppleAnimation('apple-slide-up');
  const step1Ref = useAppleAnimation('apple-slide-up');
  const step2Ref = useAppleAnimation('apple-slide-up');
  const step3Ref = useAppleAnimation('apple-slide-up');
  const step4Ref = useAppleAnimation('apple-slide-up');
  const safetyRef = useAppleAnimation('apple-slide-up');

  return (
    <section id="structure" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        {/* 제목 섹션 */}
        <div className="text-left md:text-center mb-12" ref={fadeInRef}>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            신뢰할 수 있는 투자 구조
          </h2>
          <p className="text-lg text-gray-600 md:max-w-2xl md:mx-auto">
            투명하고 체계적인 프로세스를 통해 고객님의 투자가 안전하게 관리되는 과정을 안내합니다.
          </p>
        </div>

        {/* 투자 프로세스 */}
        <div className="max-w-4xl mx-auto mb-16">
          {/* 4단계 프로세스 */}
          <div className="space-y-4 md:grid md:grid-cols-4 md:gap-8 md:space-y-0">
              {/* 1단계 */}
              <div className="flex items-start gap-4 md:flex-col md:items-center md:text-center" ref={step1Ref}>
                <div className="flex-shrink-0 md:mb-6">
                  <div className="w-16 h-16 bg-blue-500 text-white rounded-full flex items-center justify-center text-2xl font-bold border-4 border-white shadow-lg ">
                    1
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">투자 상담 및 계약</h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    전문가와 1:1 상담을 통해 투자 계획을 수립하고 계약을 진행합니다.
                  </p>
                </div>
              </div>

              {/* 2단계 */}
              <div className="flex items-start gap-4 md:flex-col md:items-center md:text-center" ref={step2Ref}>
                <div className="flex-shrink-0 md:mb-6">
                  <div className="w-16 h-16 bg-blue-500 text-white rounded-full flex items-center justify-center text-2xl font-bold border-4 border-white shadow-lg ">
                    2
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">전환사채(CB) 투자</h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    더모아벤처스가 발행하는 안정적인 전환사채에 투자금을 납입합니다.
                  </p>
                </div>
              </div>

              {/* 3단계 */}
              <div className="flex items-start gap-4 md:flex-col md:items-center md:text-center" ref={step3Ref}>
                <div className="flex-shrink-0 md:mb-6">
                  <div className="w-16 h-16 bg-blue-500 text-white rounded-full flex items-center justify-center text-2xl font-bold border-4 border-white shadow-lg ">
                    3
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">소득공제 혜택 적용</h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    투자확인서를 발급받아 연말정산 시 소득공제 혜택을 신청합니다.
                  </p>
                </div>
              </div>

              {/* 4단계 */}
              <div className="flex items-start gap-4 md:flex-col md:items-center md:text-center" ref={step4Ref}>
                <div className="flex-shrink-0 md:mb-6">
                  <div className="w-16 h-16 bg-blue-500 text-white rounded-full flex items-center justify-center text-2xl font-bold border-4 border-white shadow-lg ">
                    4
                  </div>
                </div>
                <div className="flex-1">
                  <h3 className="text-lg font-semibold text-gray-800 mb-2">만기 원금/이자 상환</h3>
                  <p className="text-gray-600 text-base leading-relaxed">
                    약정된 만기일에 투자 원금과 확정된 이자를 안전하게 상환받습니다.
                  </p>
                </div>
              </div>
          </div>
        </div>

        {/* 투자 안전장치 */}
        <div className="mt-16 bg-white p-8 rounded-2xl shadow-sm border border-gray-200" ref={safetyRef}>
          <h3 className="text-xl font-bold text-center text-gray-800 mb-6">
            투자 안전장치
          </h3>
          <div className="grid md:grid-cols-3 gap-6">
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M2.166 4.999A11.954 11.954 0 0010 1.944 11.954 11.954 0 0017.834 5c.11.65.166 1.32.166 2.001 0 5.225-3.34 9.67-8 11.317C5.34 16.67 2 12.225 2 7c0-.682.057-1.35.166-2.001zm11.541 3.708a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"/>
                </svg>
              </div>
              <h4 className="font-semibold text-gray-800 mb-1">담보 설정</h4>
              <p className="text-gray-600 text-base">투자 벤처기업의 주식 및 자산에 대한 담보권 확보</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-blue-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z"/>
                </svg>
              </div>
              <h4 className="font-semibold text-gray-800 mb-1">정기 모니터링</h4>
              <p className="text-gray-600 text-base">분기별 투자기업 실적 점검 및 투자자 보고</p>
            </div>
            
            <div className="text-center">
              <div className="w-12 h-12 mx-auto mb-3 bg-purple-100 rounded-full flex items-center justify-center">
                <svg className="w-6 h-6 text-purple-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"/>
                </svg>
              </div>
              <h4 className="font-semibold text-gray-800 mb-1">법적 보호</h4>
              <p className="text-gray-600 text-base">금융투자업법 및 자본시장법에 따른 투자자 보호</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default InvestmentStructure;